import React from 'react';
import work from "../../../Assets/workwithus.svg";
import './WorkWithUs.css';

const WorkWithUs = props => {
    return (
        <div id="we-work" className="adg-container">
            <div className="adg-header">
                Work with us
            </div>
            <div className="adg-container-data" style={{"paddingLeft":"30px"}}>
                <div className="adg-data">
                    <div className="adg-datapoint">Integrity and Quality of Service</div>
                    <div className="adg-datapoint">Latest Technology & Proprietary Tools</div>
                    <div className="adg-datapoint">We Can Recommend New Systems or Work with Your Pre-existing Accounting Software</div>
                    <div className="adg-datapoint">We Improve and Streamline Your Workflows</div>
                    {/*<div className="splash-button">*/}
                    {/*    Know more*/}
                    {/*</div>*/}
                </div>

                <div className="adg-container-banner">
                    <img src={work} alt="work-img" />
                </div>
            </div>
        </div>
    );
};

export default WorkWithUs;


// WEBPACK FOOTER //
// ./src/Components/LandingPage/WorkWithUs/WorkWithUs.js